/* global jQuery */

import $ from 'jquery';
window.$ = window.jQuery = $;

export default {
  name: 'HeaderComponent',
  props: {
    title: String,
    subtitle: String,
  },
};

(function($) {
  "use strict";

  // 文档加载后的操作
  $(document).ready(function() {
    // 案例研究图片切换
    const slideButtons = $('.slide-buttons li');
    const heroSections = $('.hero-center-section');

    slideButtons.each(function(index) {
      $(this).on('mouseenter', function() {
        slideButtons.filter('.active').removeClass('active');
        heroSections.filter('.show').removeClass("show");
        heroSections.eq(index).addClass("show");
        $(this).addClass('active');
      });
    });

    // 默认触发第一个滑块按钮的悬停事件
    slideButtons.first().trigger('mouseenter');
  });

})(jQuery);

// 将函数移动到全局作用域以避免 no-inner-declarations 规则的违规
function handleFirstScenario() {
  console.log("处理第一个场景");
}

function handleSecondScenario() {
  console.log("处理第二个场景");
}

function handleThirdScenario() {
  console.log("处理第三个场景");
}

// 定义条件以避免 no-undef 错误
const condition1 = false; // 示例值，请根据实际情况替换
const condition2 = false; // 示例值，请根据实际情况替换
const condition3 = false; // 示例值，请根据实际情况替换

// 示例函数调用
if (condition1) {
  handleFirstScenario();
}

if (condition2) {
  handleSecondScenario();
}

if (condition3) {
  handleThirdScenario();
}

